<template>
  <div>
    <el-dialog :append-to-body="true" :show-close="false" :visible.sync="verifiModalVisible"
      title="尊敬的用户，欢迎您登录医博士！"
      width="660px">
      <el-button class="btn" size="small" @click="cancel">暂不设置</el-button>
      <div class="content">
        <p style="margin-bottom:20px">
          尊敬的学员，为了您的帐户安全，请您先验证手机号。手机号验证后您可使用手机号登录系统。如您暂不设置，可在个人中心-账号设置页面进行手机号验证。</p>
        <div v-show="active === 1">
          <el-form ref="mobileForm" :model="mobileForm" :rules="mobileRules" class="formcss" label-width="100px">
            <el-form-item label="" prop="mobile">
              <img alt="" class="nlbi_cell" src="../assets/images/svg/phone.svg">
              <el-input v-model="mobileForm.mobile" placeholder="请输入手机号" style="width:284px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="mobileCode">
              <!-- 滑块验证 -->
              <div v-show="verifyShow" class="verifyMain">
                <Verify ref="verify" :captchaType="'blockPuzzle'" :imgSize="{
                    width: '240px',
                    height: '120px',
                  }" :mode="'fixed'" @success="success"></Verify>
                <div v-show="verifyOK" class="verifyOK">
                  <i class="el-icon-success" style="color:#67C23A;margin-left:12px;margin-right:8px"></i>
                  验证通过
                </div>
              </div>
              <img alt="" class="nlbi_yzm" src="../assets/images/svg/yyzm.svg">
              <el-input v-model="mobileForm.mobileCode" placeholder="请输入验证码" style="width: 194px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-button :class="{subBtnDisabled:sendSmsButtonDisabled}" :disabled="sendSmsButtonDisabled" size="small"
                style="margin-left: 10px;padding:10px 9px;"
                type="primary" @click.native="getyzm">
                {{ sendSmsButtonText }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button :class="{subBtnDisabled:nexttipDisabled}" :disabled="nexttipDisabled" style="width:284px;"
                type="primary"
                @click.native="nextMobile">下一步
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active === 2">
          <div class="new_content">
            <div style="padding:5% 0;">
              <img alt="" src="../assets/images/svg/loginok.svg">
              <p class="new_zc_sucess">验证成功</p>
              <p class="new_zc_welcome">
                弹窗即将在<span class="text">{{ timeDown }}</span>秒后关闭
              </p>
            </div>
          </div>
        </div>
      </div>
    
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { aesEncryptWord } from './verifition/utils/ase.js'
import { bindMobile } from '../api/api'
import { getsms } from '../api/apiLoginVerify'
import Verify from '../components/verifition/Verify.vue'
import { phoneReg } from '../utils/commonReg.js'

export default {
  name: 'verifiModal',
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validateVPhoneCode = (rule, value, callback) => {
      if (!this.mobileForm.mobile) {
        callback(new Error('请先获取手机验证码'))
      } else if (!value) {
        callback(new Error('请输入手机验证码'))
      } else {
        callback()
      }
    }
    return {
      phoneReg: phoneReg,
      timeDown: 5,
      dialogVisible: true,
      active: 1,
      verifyOK: false,
      verifyShow: false,
      yzmeffect: false, //是否获取验证码并有效
      smsTime: 0,
      captchaVerification: '',
      mobileForm: {
        mobile: '',
        mobileCode: ''
      },
      mobileRules: {
        mobile: [{
          validator: validateMobile,
          trigger: 'blur'
        }],
        mobileCode: [{
          validator: validateVPhoneCode,
          trigger: 'blur'
        }]
      }
      
    }
  },
  components: {
    Verify
  },
  props: {
    verifiModalVisible: {
      type: Boolean,
      default: false
    },
    usermobile: {
      type: String,
      default: ''
    }
  },
  watch: {},
  computed: {
    ...mapGetters([
      'userInfo'
      // ...
    ]),
    sendSmsButtonText() {
      return this.smsTime > 0 ? this.smsTime + 's后重新获取' : '获取验证码'
    },
    sendSmsButtonDisabled() {
      if (this.mobileForm.mobile.length < 1) {
        return true
      } else if (this.yzmeffect) {
        return true
      } else {
        return false
      }
    },
    nexttipDisabled() {
      if (this.mobileForm.mobile.length < 1 || this.mobileForm.mobileCode.length < 1) {
        return true
      } else {
        return false
      }
    }
  },
  
  mounted() {
  },
  
  methods: {
    ...mapActions([
      'getUserInfo'
    ]),
    success(params) {
      this.verifyShow = false
      this.captchaVerification = params
      this.sendSmsMethod()
    },
    smsTimer() {
      if (this.smsTime > 0) {
        this.yzmeffect = true
        this.smsTime--
        // this.sendSmsButtonDisabled = true
        setTimeout(this.smsTimer, 1000)
      } else {
        // this.sendSmsButtonDisabled = false
        this.yzmeffect = false
      }
    },
    getyzm() {
      this.$refs.mobileForm.validateField('mobile', (error) => {
        if (!error) {
          this.verifyShow = true
        }
      })
    },
    /**
     * @description: 发送验证码
     * @author: lly
     */
    sendSmsMethod() {
      //flag 3  除了他自己是否被占用
      let param = {
        mobile: aesEncryptWord(this.mobileForm.mobile),
        captchaVerification: this.captchaVerification.captchaVerification,
        flag: 3,
        uuid: this.userInfo.uuid
      }
      getsms(param).then(res => {
        this.$message.success('已发送手机验证码')
        this.smsTime = 60
        this.smsTimer()
      })
      
    },
    nextMobile() {
      // this.active++
      // if (this.active++ > 2) this.active = 0
      //  this.userInfo()
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          let param = {
            mobile: this.mobileForm.mobile,
            code: this.mobileForm.mobileCode
          }
          bindMobile(param).then(({data}) => {
            if (data.code == 0) {
              this.getUserInfo()
              if (this.active++ > 2) this.active = 0
              this.timeDown = 5
              this.smstimeDown()
            } else {
              this.$message.warning(data.msg)
            }
          })
          
        } else {
          return false
        }
      })
    },
    cancel() {
      this.$emit('update:verifiModalVisible', false)
    },
    smstimeDown() {
      //倒计时5s
      if (this.timeDown > 0) {
        this.timeDown--
        setTimeout(this.smstimeDown, 1000)
      } else {
        this.$emit('update:verifiModalVisible', false)
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
.subBtnDisabled {
  border-color: #FFFFFF !important;
  background: rgba(56, 188, 213, 0.3) !important;
}

.verifyMain {
  position: absolute;
  top: -146px;
  left: 13px;
}

.content {
  width: 540px;
  margin: 0 auto;
  
  .new_content {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    
    .new_zc_sucess {
      font-size: 18px;
      line-height: 34px;
      height: 34px;
      color: #595959;
    }
    
    .new_zc_welcome {
      font-size: 16px;
      line-height: 34px;
      height: 34px;
      
      .text {
        color: #38BCD5;
      }
    }
  }
  
  .nlbi_cell {
    position: absolute;
    z-index: 99;
    top: 10px;
    left: 10px;
    background: #FFFFFF
  }
  
  .nlbi_yzm {
    position: absolute;
    z-index: 99;
    top: 12px;
    left: 10px;
    background: #FFFFFF
  }
}

.btn {
  position: absolute;
  top: 20px;
  right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/VerifiModal.vue